<template>
    <v-dialog v-model="emailDialog" max-width="588">
        <v-card class="pa-6 rounded-sm">
            <h6 class="text-h6 primaryDark--text">Направить по электронной почте</h6>
            <v-divider class="my-4" />
            <v-form ref="form" @submit.prevent="sendEmailNotification">
                <v-text-field type="email" :rules="[validationRules.required, validationRules.email]" v-model="e_mail" label="E-mail" outlined color="black" />
                <div class="d-flex justify-end">
                    <v-btn @click="closeDialog" rounded class="mr-4" outlined color="gray">Отмена</v-btn>
                    <v-btn type="submit" rounded color="gray" class="white--text">Отправить</v-btn>
                </div>
            </v-form>
        </v-card>
    </v-dialog>
</template>
<script>
import { validationRules } from '@/utils/validationRules';
export default {
    name: 'EmailDialog',
    props: ['value', 'item'],
    data: function() {
        return {
            dialog: false,
            e_mail: null
        };
    },
    inject: ['actSendEmail'],
    computed: {
        emailDialog: {
            get() {
                return this.value;
            },
            set(val) {
                this.$emit('input', val);
            }
        },
        validationRules() {
            return validationRules;
        },
        isFormValid() {
            return this.$refs.form.validate();
        }
    },
    methods: {
        sendEmail() {
            this.actSendEmail(this.item);
            this.emailDialog = false;
        },
        sendEmailNotification() {
            if (!this.isFormValid) return;
            this.item['e_mail'] = this.e_mail;
            this.actSendEmail(this.item);
            this.emailDialog = false;
        },
        closeDialog() {
            this.emailDialog = false;
            this.clearForm();
        },
        clearForm() {
            this.$refs.form.resetValidation();
            this.e_mail = null;
        }
    }
};
</script>

<style scoped></style>
